module.exports = __webpack_public_path__ + "img/tb-08@2x.6a779324.png";